var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosGoogleMeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3302_5504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4805 7.98646L12.2866 10.1496L14.7155 11.7758L15.1379 8.00011L14.7155 4.30957L12.2401 5.73812L10.4805 7.98646Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.4245V14.642C0 15.3766 0.569105 15.9731 1.27036 15.9731H4.34095L4.97678 13.5421L4.34095 11.4245L2.2343 10.7583L7.23684e-05 11.4245H0Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34095 0L0 4.54855L2.23445 5.21319L4.34095 4.54855L4.9652 2.45983L4.34095 0Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 11.4258H4.34094V4.54834H6.10352e-05V11.4258Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4885 1.92608L14.7154 4.30985V11.776L17.4999 14.169C17.9168 14.5112 18.5265 14.1994 18.5265 13.6441V2.44035C18.5265 1.87899 17.9022 1.56869 17.4884 1.92615",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4805 7.98633V11.4243H4.34094V15.9728H13.4452C14.1464 15.9728 14.7155 15.3764 14.7155 14.6417V11.7757L10.4805 7.98633Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4452 0H4.34094V4.54855H10.4805V7.9865L14.7155 4.30954V1.33118C14.7155 0.596398 14.1464 7.58294e-05 13.4452 7.58294e-05",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3302_5504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5263,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGoogleMeet);
export default __webpack_public_path__ + "static/media/logos_google-meet.a1e9fe2a3b5c3b6a63d2657b76897903.svg";
export { ForwardRef as ReactComponent };